
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-in/[slug]",
      function () {
        return require("private-next-pages/check-in/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check-in/[slug]"])
      });
    }
  